<script setup lang="ts">
import { Toaster } from '@tsogtoodev/babi-toast'
import { SIDEBAR_WIDTH, SIDEBAR_WIDTH_ICON } from "@/components/ui/sidebar/utils"
import { useMediaQuery } from "@vueuse/core"

const route = useRoute()
const { fetchActiveSubscription } = useSubscriptionStore()
const audioPlayer = useAudioPlayer()
const isPlayerShowing = computed(() => !!audioPlayer.currentTrack.value)
const sidebarState = useState<"expanded" | "collapsed">("sidebarState", () => "expanded")
const isMobile = useMediaQuery("(max-width: 768px)")
const hasAppSidebar = computed(() => route.path.startsWith("/app"))
const sidebarCenterOffset = computed(() => {
  if (!hasAppSidebar.value || isMobile.value) return "50%"
  return sidebarState.value === "expanded"
    ? `calc(50% + (${SIDEBAR_WIDTH} / 2))`
    : `calc(50% + (${SIDEBAR_WIDTH_ICON} / 2))`
})
const toasterOffset = computed(() => ({
  top: "1rem",
  right: "1rem",
  left: "1rem",
  center: sidebarCenterOffset.value,
  bottom: isPlayerShowing.value ? "7.5rem" : "0.5rem",
}))

watch(route, async () => {
  if (route.path.includes('/app')) {
    await fetchActiveSubscription()
  }
}, { immediate: true })
</script>

<template>
  <div
    class="scroll-smooth babi-center-scope"
    :style="{ '--babi-center-left': sidebarCenterOffset }"
  >
    <Toaster position="top-right" :offset="toasterOffset" />

    <LoadingIndicator />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
